export default __webpack_public_path__ + "static/media/Schulung Seetel IT-Sicherheit.419414c1.jpg";